// import React, { useState, useCallback, useEffect } from "react";
// import { IoMdAdd } from "react-icons/io";
// import { IoHeartOutline, IoHeartSharp } from "react-icons/io5";
// import { BASE_URL, USER_URL } from "../../constant/api";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { useSession } from "../../ApiCalls/useSession";
// import AddToCartModel from "../Home/AddToCartModel/AddToCartModel";
// import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

// function DoubleRowProductCard({ products = [], title, bg, view_all_url }) {
//     useSession();
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [wishlist, setWishlist] = useState([]);

//     const openModal = useCallback((product) => {
//         setSelectedProduct(product);
//         setIsModalOpen(true);
//     }, []);

//     const closeModal = useCallback(() => {
//         setIsModalOpen(false);
//         setSelectedProduct(null);
//     }, []);

//     useEffect(() => {
//         const getWishlist = async () => {
//             // const token = localStorage.getItem("token");
//             // const sessionId = localStorage.getItem("sessionid");
//             // const headers = token
//             //     ? { Authorization: `Token ${token}` }
//             //     : { "Session-Id": sessionId };

//             try {
//                 const response = await USER_URL.get(`/products/wishlist/`);
//                 setWishlist(response.data.items.map((item) => item.product_id));
//             } catch (error) {
//                 console.error("Error fetching wishlist:", error);
//             }
//         };

//         getWishlist();
//     }, []);

//     const toggleWishlist = async (product_id) => {
//         try {
//             const isWishlisted = wishlist.includes(product_id);
//             // const token = localStorage.getItem("token");
//             // const sessionId = localStorage.getItem("sessionid");
//             // const headers = token
//             //     ? { Authorization: `Token ${token}` }
//             //     : { "Session-Id": sessionId };

//             await USER_URL.post(
//                 `/products/wishlist/`,
//                 { product_id },
//                 // { headers }
//             );

//             setWishlist((prev) =>
//                 isWishlisted
//                     ? prev.filter((id) => id !== product_id)
//                     : [...prev, product_id]
//             );
//         } catch (error) {
//             console.error("Error toggling wishlist:", error);
//         }
//     };

//     const renderStars = (rating) => {
//         const totalStars = 5;
//         const filledStars = Math.floor(rating);
//         const hasHalfStar = rating % 1 >= 0.5;
//         const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0);

//         return (
//             <div className="flex justify-center items-center">
//                 {[...Array(filledStars)].map((_, index) => (
//                     <FaStar key={`filled-${index}`} className="text-yellow-500" />
//                 ))}
//                 {hasHalfStar && <FaStarHalfAlt className="text-yellow-500" />}
//                 {[...Array(emptyStars)].map((_, index) => (
//                     <FaRegStar key={`empty-${index}`} className="text-gray-400" />
//                 ))}
//             </div>
//         );
//     };

//     const renderProductCard = (product) => (
//         <div
//             key={product.id}
//             className="w-48 md:w-60 flex-none rounded-lg bg-white p-3 border-2 border-gray-300 justify-between shadow-md"
//         >
//             <div className="flex justify-between items-center text-sm text-brand-light-gray ">
//                 <span className="rounded-lg bg-red-600 p-1">
//                     {product.offer_percent ? `-${product.offer_percent}%` : ""}
//                 </span>
//                 <span
//                     className="text-red-700 text-2xl cursor-pointer"
//                     onClick={() =>
//                         wishlist.includes(product.id)
//                             ? setWishlist((prev) => prev.filter((id) => id !== product.id))
//                             : toggleWishlist(product.id)
//                     }
//                 >
//                     {wishlist.includes(product.id) ? <IoHeartSharp /> : <IoHeartOutline />}

//                 </span>

//             </div>
//             <Link to={`/product-details/${product.id}`}>
//                 <img
//                     src={
//                         product.product_images?.[0]?.image
//                             ? product.product_images[0].image.startsWith(BASE_URL)
//                                 ? product.product_images[0].image
//                                 : `${BASE_URL}${product.product_images[0].image}`
//                             : "/images/default-product.png"
//                     }
//                     alt={product.name || "Product"}
//                     className="mb-2 h-32 w-full object-contain my-2 transition transform hover:scale-105"
//                     onError={(e) => {
//                         e.target.src = "/images/default-product.png";
//                     }}
//                 />
//             </Link>
//             <div className="flex flex-col  items-start gap-2 justify-end">
//                 <h3 className="font-semibold">
//                     <Link to={`/product-details/${product.id}`}>
//                         {product.name || "No Name Available"}
//                     </Link>
//                 </h3>
//                 <p className="line-clamp-1 text-sm text-gray-600">
//                     {product.description || "No description available"}
//                 </p>
//                 <div className="flex flex-col justify-center items-start gap-1 text-xs md:text-sm">
//                     {renderStars(product.product_rating)}
//                     <span className="text-center text-gray-500">
//                         {product.product_rating} ({product.product_review_count} Reviews)
//                     </span>
//                 </div>
//                 <div className="flex justify-between  w-full">
//                     <p className="text-lg font-bold">
//                         {product.price ? `$${product.price}` : "N/A"}
//                     </p>
//                     <span
//                         className="rounded-md bg-brand-primary py-1 px-2 text-white cursor-pointer"
//                         onClick={() => openModal(product)}
//                     >
//                         ADD
//                     </span>
//                 </div>
//             </div>
//         </div>
//     );

//     let row1 = [];
//     let row2 = [];

//     if (products.length <= 10) {
//         row1 = products.slice(0, 5); // First 5 items
//         row2 = products.slice(5); // Remaining items
//     } else {
//         const midIndex = Math.floor(products.length / 2);
//         row1 = products.slice(0, midIndex); // First half
//         row2 = products.slice(midIndex); // Second half
//     }

//     return (
//         <div style={{ backgroundColor: bg }} className="my-2 pt-5">
//             <div className="flex justify-between items-center px-5">
//                 <h2 className="text-2xl md:text-3xl font-semibold mb-4">{title}</h2>
//                 <p className="text-xl text-brand-text-light hover:text-brand-primary transition duration-500 ease-in-out">
//                     <Link to={view_all_url}>view all</Link>
//                 </p>
//             </div>
//             <div className="">
//                 {[row1, row2].map((row, index) => (
//                     <div key={index} className="flex space-x-4 overflow-x-auto p-4">
//                         {row.length >=0 ? row.map(renderProductCard) : <p>No products available.</p>}
//                     </div>
//                 ))}
//            </div>
//             <AddToCartModel
//                 selectedProduct={selectedProduct}
//                 isModalOpen={isModalOpen}
//                 closeModal={closeModal}
//             />
//         </div>
//     );
// }

// export default DoubleRowProductCard;

import React, { useState, useCallback, useEffect } from "react";
import { IoMdAdd } from "react-icons/io";
import { IoHeartOutline, IoHeartSharp } from "react-icons/io5";
import { BASE_URL, USER_URL } from "../../constant/api";
import axios from "axios";
import { Link } from "react-router-dom";
import { useSession } from "../../ApiCalls/useSession";
import AddToCartModel from "../Home/AddToCartModel/AddToCartModel";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

function DoubleRowProductCard({ products = [], title, bg, view_all_url }) {
  useSession();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [wishlist, setWishlist] = useState([]);

  const openModal = useCallback((product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  }, []);

  useEffect(() => {
    const getWishlist = async () => {
      // const token = localStorage.getItem("token");
      // const sessionId = localStorage.getItem("sessionid");
      // const headers = token
      //     ? { Authorization: `Token ${token}` }
      //     : { "Session-Id": sessionId };

      try {
        const response = await USER_URL.get(`/products/wishlist/`);
        setWishlist(response.data.items.map((item) => item.product_id));
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      }
    };

    getWishlist();
  }, []);

  const toggleWishlist = async (product_id) => {
    try {
      const isWishlisted = wishlist.includes(product_id);
      // const token = localStorage.getItem("token");
      // const sessionId = localStorage.getItem("sessionid");
      // const headers = token
      //     ? { Authorization: `Token ${token}` }
      //     : { "Session-Id": sessionId };

      await USER_URL.post(
        `/products/wishlist/`,
        { product_id },
        // { headers }
      );

      setWishlist((prev) =>
        isWishlisted
          ? prev.filter((id) => id !== product_id)
          : [...prev, product_id],
      );
    } catch (error) {
      console.error("Error toggling wishlist:", error);
    }
  };

  const renderStars = (rating) => {
    const totalStars = 5;
    const filledStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="flex items-center justify-center">
        {[...Array(filledStars)].map((_, index) => (
          <FaStar key={`filled-${index}`} className="text-yellow-500" />
        ))}
        {hasHalfStar && <FaStarHalfAlt className="text-yellow-500" />}
        {[...Array(emptyStars)].map((_, index) => (
          <FaRegStar key={`empty-${index}`} className="text-gray-400" />
        ))}
      </div>
    );
  };

  const renderProductCard = (product) => (
    <div
      key={product.id}
      className="flex h-full min-h-[360px] w-48 hover:scale-105 transition-transform ease-in-out duration-300  flex-none flex-col justify-between rounded-lg border-2 border-gray-300 bg-white p-3 shadow-md md:w-60" // added min height and flex column
    >
      {/* Top row: Offer & Wishlist */}
      <div className="mb-2 flex items-center justify-between text-sm text-brand-light-gray">
        {product.offer_percent && (
          <span className="rounded-lg bg-red-600 p-1 px-2">
            {product.offer_percent ? `-${product.offer_percent}%` : ""}
          </span>
        )}
        <span
          className="cursor-pointer text-2xl text-red-700"
          onClick={() => toggleWishlist(product.id)}
        >
          {wishlist.includes(product.id) ? (
            <IoHeartSharp />
          ) : (
            <IoHeartOutline />
          )}
        </span>
      </div>

      {/* Image */}
      <Link
        to={`/product-details/${product.id}`}
        className="mb-2 flex justify-center"
      >
        <img
          src={
            product.product_images?.[0]?.image
              ? product.product_images[0].image.startsWith(BASE_URL)
                ? product.product_images[0].image
                : `${BASE_URL}${product.product_images[0].image}`
              : "/images/default-product.png"
          }
          alt={product.name || "Product"}
          className="h-32 w-full transform object-contain transition "
          onError={(e) => {
            e.target.src = "/images/default-product.png";
          }}
        />
      </Link>

      {/* Middle info: name, desc, ratings */}
      <div className="flex flex-grow flex-col justify-start">
        <h3 className="mb-1 text-sm font-semibold hover:text-green-500">
          <Link to={`/product-details/${product.id}`}>
            {product.name || "No Name Available"}
          </Link>
        </h3>
        <p className="mb-1 line-clamp-1 text-sm text-gray-600">
          {product.description || "No description available"}
        </p>
        <div className="mb-2 flex flex-col items-start justify-center gap-1 text-xs md:text-sm">
          {renderStars(product.product_rating)}
          <span className="text-gray-500">
            {product.product_rating} ({product.product_review_count} Reviews)
          </span>
        </div>
      </div>

      {/* Bottom row: price & ADD */}
      <div className="mt-auto flex items-center justify-between pt-2">
        <p className="text-lg font-bold text-gray-800">
          {product.price ? `${product.currency_symbol} ${product.price}` : "N/A"}
        </p>
        <span
          className="cursor-pointer rounded-md bg-brand-primary px-3 py-1 text-sm text-white"
          onClick={() => openModal(product)}
        >
          ADD
        </span>
      </div>
    </div>
  );

  let row1 = [];
  let row2 = [];

  if (products.length <= 10) {
    row1 = products.slice(0, 5); // First 5 items
    row2 = products.slice(5); // Remaining items
  } else {
    const midIndex = Math.floor(products.length / 2);
    row1 = products.slice(0, midIndex); // First half
    row2 = products.slice(midIndex); // Second half
  }

  return (
    <div style={{ backgroundColor: bg }} className="my-2 pt-5">
      <div className="flex items-center justify-between px-5">
        <h2 className="mb-4 text-2xl font-semibold md:text-3xl">{title}</h2>
        {/* <p className="text-xl text-brand-text-light transition duration-500 ease-in-out hover:text-brand-primary">
          <Link to={view_all_url}>view all</Link>
        </p> */}
      </div>
      <div className="">
        {[row1, row2].map((row, index) => (
          <div key={index} className="flex space-x-4 overflow-x-auto p-4">
            {row.length >= 0 ? (
              row.map(renderProductCard)
            ) : (
              <p>No products available.</p>
            )}
          </div>
        ))}
      </div>
      <AddToCartModel
        selectedProduct={selectedProduct}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
      />
    </div>
  );
}

export default DoubleRowProductCard;
